module.exports = __webpack_public_path__ + "static/media/team2.6d9dc8cd.png";